import { useCallback, useState } from 'react';
import { useMutation } from '@ts-core/lib/apollo';

import { useMutationCompletionHandler } from '@ts-core/lib/apollo';
import { useFilteredData } from '@ts-core/hooks/ui';
import { isValidEmail } from '@ts-core/utils/utils';

import { addStudentsToCourseMutation } from '../../graphql/mutations';

const fileErrorMessage = 'El archivo CSV es inválido, revisa que el formato sea: Nombre, Email, Documento, Grupo';

export default function useImportStudentsFromFileForm({ courseId, onStudentsImported }) {
  const { onError } = useMutationCompletionHandler();

  const [allStudents, setAllStudents] = useState();
  const [error, setError] = useState();

  const { filteredData: students, onFilterData: onFilterStudents } = useFilteredData({
    list: allStudents,
    fields: ['name', 'email', 'personalId'],
  });

  const onFileLoaded = useCallback((data) => {
    setError();
    const result = data
      .map((d) => {
        const [name, email, personalId, group] = d;
        return {
          name: name?.trim(),
          email: email?.trim(),
          personalId: personalId?.trim(),
          group: group?.trim(),
        };
      })
      .filter((s) => s.name && s.email && isValidEmail(s.email) && s.personalId && s.group);

    if (!result?.length) {
      setError(fileErrorMessage);
    }
    setAllStudents(result);
  }, []);

  /**
   * Add students
   */
  const [addStudentsToCourse, { loading: submitting }] = useMutation(addStudentsToCourseMutation, {
    onError,
    onCompleted: onStudentsImported,
  });
  const onImportStudents = useCallback(() => {
    addStudentsToCourse({
      variables: {
        courseId,
        input: { students: allStudents },
      },
    });
  }, [allStudents, courseId, addStudentsToCourse]);

  /**
   * Clean form
   */
  const onCleanForm = useCallback(() => {
    setAllStudents();
  }, []);

  return {
    students: allStudents && students,
    submitting,
    error,

    onFileLoaded,
    onFilterStudents,
    onImportStudents,

    onCleanForm,
  };
}
